<template>
    <div>
        <v-row>
            <v-col cols="12" class="d-flex justify-end">
                <AutocompleteComp autoSelectFirst :items="AsistenciaClase" item-text="desc_curso" item-value="id_curso"
                    v-model="claseCurso" returnObject @change="listClaseindicador" textLabel="Área" />
            </v-col>
            <v-col cols="12" md="6">
                <v-card outlined>
                    <v-card-title class="d-flex justify-center text-subtitle-2 primary--text">
                        <v-icon small left color="primary">
                            fas fa-school
                        </v-icon>
                        Asistencia al colegio :
                        <span class="ml-2">{{ Number(porcentajeColegio).toFixed(2) }} %</span>
                    </v-card-title>
                    <v-card-text>
                        <div v-if="Asistenciacolegio.length < 1">
                            <v-card outlined>
                                <v-card-text style="height: 320px" class="d-flex justify-center align-center ">
                                    Seleccione un estudiante
                                </v-card-text>
                            </v-card>
                        </div>
                        <v-row dense v-else>
                            <v-col cols="12" class="d-flex justify-center">
                                <div id="chart">
                                    <apexchart type="pie" width="480" :options="chartOptions" :series="series">
                                    </apexchart>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-subtitle class="d-flex text-center">
                        <span>La siguiente gráfica representa la asistencia al colegio por parte del estudiante.
                            Indicando el porcentaje de cada índice de conducta en la leyenda .</span>
                    </v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card outlined>
                    <v-card-title class="text-subtitle-2 primary--text d-flex justify-center">
                        <v-icon left small color="primary">
                            fas fa-chalkboard-teacher
                        </v-icon>
                        Asistencia a clases :
                        <span class="ml-2">
                            {{ Number(porcenajeClase).toFixed(2) }} %
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <div v-if="AsistenciaClase.length < 1">
                            <v-card outlined>
                                <v-card-text style="height: 320px" class="d-flex justify-center align-center">
                                    Seleccione un estudiante
                                </v-card-text>
                            </v-card>
                        </div>
                        <v-row dense v-else>

                            <v-col cols="12" class="d-flex justify-center">
                                <div id="chart">
                                    <apexchart type="pie" width="480" :options="chartOptions2" :series="series2">
                                    </apexchart>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-subtitle class="d-flex text-center">
                        <span>
                            La siguiente gráfica representa la asistencia por área, indicando el porcentaje de cada
                            índice de conducta en la leyenda.
                        </span>
                    </v-card-subtitle>

                </v-card>
            </v-col>

        </v-row>
    </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import axios from "@/helpers/axios";
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';


export default {
    props: ['filter'],
    components: {
        apexchart: VueApexCharts,
        AutocompleteComp
    },
    data: () => ({
        Asistenciacolegio: [],
        AsistenciaClase: [],
        claseCurso: "",
        porcentajeColegio: "",
        porcenajeClase: "",
        showChart: false,

        // Asistencia al colegio
        series: [],
        chartOptions: {
            chart: {
                width: 480,
                type: 'pie',
            },
            legend: {
                position: 'right',
                offsetY: 100,
            },

            labels: ['Presente', 'Tardanza justificada', 'Tardanza injustificada', 'Falta justificada', 'Falta injustificada'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 400
                    },
                    legend: {
                        position: 'bottom',
                    }


                }
            }],
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return Number(val).toFixed(2) + "%"
                },

            }
        },

        // Asistencia a la clase
        series2: [],
        chartOptions2: {
            chart: {
                width: 480,
                type: 'pie',
            },
            legend: {
                position: 'right',
                offsetY: 100,
            },
            labels: ['Presente', 'Tardanza justificada', 'Tardanza injustificada', 'Falta justificada', 'Falta injustificada'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 300
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }],
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return Number(val).toFixed(2) + "%"
                },

            }
        },

    }),


    mounted() {
        this.getAsistenciaClaseChart();
        this.getAsistenciaColegioChart();
    },
    methods: {


        async getAsistenciaColegioChart() {
            this.Asistenciacolegio = [];
            try {
                const response = await axios.post("/metricaAsistenciaColegio/", { id_alumno: this.filter.id_alumno })
                this.Asistenciacolegio = response.data[0]
                let totalAsistencias = this.Asistenciacolegio.total_asistencia + this.Asistenciacolegio.total_tardanzas_justificadas + this.Asistenciacolegio.total_tardanzas_injustificadas;
                let totalFaltas = this.Asistenciacolegio.total_faltas_injustificadas + this.Asistenciacolegio.total_faltas_justificadas;
                let totalNormalizado = totalAsistencias + totalFaltas;
                this.porcentajeColegio = (totalAsistencias / totalNormalizado) * 100;
                this.series = [
                    this.Asistenciacolegio.total_asistencia,
                    this.Asistenciacolegio.total_tardanzas_justificadas,
                    this.Asistenciacolegio.total_tardanzas_injustificadas,
                    this.Asistenciacolegio.total_faltas_justificadas,
                    this.Asistenciacolegio.total_faltas_injustificadas]

                this.showChart = true;

            } catch (error) {
                console.error(error);
            }
        },

        async getAsistenciaClaseChart() {
            this.series2 = [];
            this.AsistenciaClase = [];

            try {
                const response = await axios.post("/metricaAsistenciaClase/", { id_alumno: this.filter.id_alumno })
                this.AsistenciaClase = response.data
                let totalAsistencias = 0;
                let totalFaltas = 0;
                this.AsistenciaClase.forEach(curso => {
                    totalAsistencias += curso.total_asistencia + curso.total_tardanzas_justificadas + curso.total_tardanzas_injustificadas;
                    totalFaltas += curso.total_faltas_justificadas + curso.total_faltas_injustificadas;
                });

                let totalNormalizado = totalAsistencias + totalFaltas;
                this.porcenajeClase = (totalAsistencias / totalNormalizado) * 100;
                this.series2 = [
                    this.AsistenciaClase[0].total_asistencia,
                    this.AsistenciaClase[0].total_tardanzas_justificadas,
                    this.AsistenciaClase[0].total_tardanzas_injustificadas,
                    this.AsistenciaClase[0].total_faltas_justificadas,
                    this.AsistenciaClase[0].total_faltas_injustificadas
                ]
                this.showChart = true;
            } catch (error) {
                console.error(error);
            }
        },

        listClaseindicador() {
            this.series2 = [
                this.claseCurso.total_asistencia,
                this.claseCurso.total_tardanzas_justificadas,
                this.claseCurso.total_tardanzas_injustificadas,
                this.claseCurso.total_faltas_justificadas,
                this.claseCurso.total_faltas_injustificadas
            ];
        }
    },





}


</script>
